export const FLOW_ORG_PAGES = {
    flowOrgAdminUI: 'flowOrgAdminUI',
    flowOrgJoinedUI: 'flowOrgJoinedUI',
    localRuntimeCreate: 'localRuntimeCreate',
    localRuntimeEdit: 'localRuntimeEdit',
    localRuntimeDisplayToken: 'localRuntimeDisplayToken',
};
